<template>
  <div
    class="modal fade"
    id="viewMailModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="viewModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100" id="viewModalContent" v-if="mailData">
        <div class="modal-header">
          <h4 class="modal-title" id="viewModalLabel">{{ mailStatus }}</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="template-container">
            <p class="sub-margin">
              <span class="heading">To:</span>{{ mailData.mail_to }}
            </p>
            <p class="sub-margin">
              <span class="heading">Subject:</span>{{ mailData.mail_subject }}
            </p>
            <div class="sub-margin">
              <span class="heading">CC:</span>
              <ul v-if="mailData.mail_cc && mailData.mail_cc.length">
                <li v-for="(cc, index) in mailData.mail_cc" :key="index">
                  {{ cc }}
                </li>
              </ul>
              <span v-else><em>Not added</em></span>
            </div>
            <div class="sub-margin">
              <span class="heading">BCC:</span>
              <ul v-if="mailData.mail_bcc && mailData.mail_bcc.length">
                <li v-for="(bcc, index) in mailData.mail_bcc" :key="index">
                  {{ bcc }}
                </li>
              </ul>
              <span v-else><em>Not added</em></span>
            </div>
            <div class="sub-margin">
              <span class="heading">Body:</span>
              <div style="height: 21vh; overflow-y: auto; padding: 0px 10px">
                <safe-content
                  v-if="mailData.mail_body"
                  :content="mailData.mail_body"
                  tag="span"
                ></safe-content>
              </div>
            </div>
          </div>
          <p class="text-danger" v-if="mailData.error">
            * {{ mailData.error }}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cp" data-dismiss="modal">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @memberof module:MailBox
 * @namespace components.view_template_modal
 * @description Modal for preview of template
 */
export default {
  props: ["mailData"],
  computed: {
    mailStatus: function () {
      return this.mailData.mail_status
        .match(/[a-z]+/gi)
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        })
        .join("");
    },
  },
};
</script>

<style scoped>
.template-container {
  border: 1px solid #8b509661;
  margin-bottom: 10px;
}
</style>
